export interface Volume {
  code: string
  name: string
  subtitle: string
  count: string
  /** The problem this volume solves. */
  intro: string
  focus: { title: string; detail: string }[]
  result: string
}

export const volumes: Volume[] = [
  {
    code: '01',
    name: 'The Foundation Blueprint',
    subtitle: 'Grip, Stance & Core Mechanics',
    count: '25 Lessons',
    intro:
      'Teaching beginners is rewarding but exhausting without a plan. This volume gives you a step-by-step roadmap to build indestructible basics without guessing a single cue.',
    focus: [
      {
        title: 'Master the V-Grip',
        detail: 'Exact hand placement and pressure points.',
      },
      {
        title: 'The Athletic Base',
        detail: 'Posture, balance and weight distribution.',
      },
      {
        title: 'Court Awareness',
        detail: 'Zonal positioning and the “Kitchen” fundamentals.',
      },
    ],
    result:
      'Every beginner walks off the court having learned something specific — and so do you.',
  },
  {
    code: '02',
    name: 'Technical Mastery & Bio-Mechanics',
    subtitle: 'Strokes, Technique & Power',
    count: '25 Lessons',
    intro:
      'Students demand technical fixes. This volume provides the science of the stroke for drives, drops, resets and volleys.',
    focus: [
      {
        title: 'The Physics of the Swing',
        detail: 'Swing paths and contact points.',
      },
      {
        title: 'The Third-Shot Drop',
        detail: 'Purpose, mechanics and live-ball progressions.',
      },
      {
        title: 'Net Dominance',
        detail: 'Punch volleys and overhead selection.',
      },
    ],
    result:
      'You stop saying “try again” and start naming the exact mechanical cause.',
  },
  {
    code: '03',
    name: 'Strategy & Tactics',
    subtitle: 'Point Construction & Game IQ',
    count: '25 Lessons',
    intro:
      'Most players hit the ball well but play “dumb”. Teach them how to win the chess match of pickleball.',
    focus: [
      {
        title: 'Shot Selection',
        detail: 'Risk vs. reward and when to pull the trigger.',
      },
      {
        title: 'Kitchen Strategy',
        detail: 'Controlling the pace and forcing attackable balls.',
      },
      {
        title: 'Reading Opponents',
        detail: 'Identifying weaknesses and tactical exploitation.',
      },
    ],
    result:
      'Your players stop losing points they had already won.',
  },
  {
    code: '04',
    name: 'Doubles Excellence',
    subtitle: 'Partnership, Stacking & Movement',
    count: '25 Lessons',
    intro:
      'Doubles requires team coordination. Teach your students to move as a single, lethal unit.',
    focus: [
      {
        title: 'Synchronized Movement',
        detail: 'Covering the middle and transitional timing.',
      },
      {
        title: 'The Stacking System',
        detail: 'When, why and how to execute it flawlessly.',
      },
      {
        title: 'Team Communication',
        detail: 'Pre-point planning and mid-rally cues.',
      },
    ],
    result:
      'Two players stop being two players and start being a team.',
  },
  {
    code: '05',
    name: 'Elite Drills & Skill-Building',
    subtitle: 'High-Repetition Mastery',
    count: '25 Lessons',
    intro:
      'Turn concepts into habits with structured drills for accuracy, pressure and consistency.',
    focus: [
      {
        title: 'Serve & Return Accuracy',
        detail: 'Target-based drills for deep placement.',
      },
      {
        title: 'Transition Zone Drills',
        detail: 'Mastering “No-Man’s Land”.',
      },
      {
        title: 'Conditioning Drills',
        detail: 'Building pickleball-specific stamina.',
      },
    ],
    result:
      'Skills survive the pressure of a real game, not just a friendly feed.',
  },
  {
    code: '06',
    name: 'Professional Coaching Mastery',
    subtitle: 'The Business of Being a Pro',
    count: '25 Lessons',
    intro:
      'Transform from a “hitter” into a Master Instructor who runs a session like a professional.',
    focus: [
      {
        title: 'Session Flow',
        detail: 'How to pace 60, 90 and 120-minute clinics.',
      },
      {
        title: 'Error Detection',
        detail: 'Spotting the root cause of a bad shot in seconds.',
      },
      {
        title: 'Group Management',
        detail: 'How to keep 8 players engaged on one court.',
      },
    ],
    result:
      'You are booked out because your sessions feel unmistakably professional.',
  },
]
